export default __webpack_public_path__ + "static/3_4-382fa3fa23d647763ca4cc3c42e236c2.png";